import React, { useState, useEffect, useRef } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useBreakpoint } from '@next-common/breakpoint';
import { globalTheme } from '../../theme';
import { CustomTransition } from './CustomTransition';
import { StyledCloseIcon, StyledChevronIcon, StyledChevronIconNoTitle, StyledCloseIconNoTitle } from './CustomModal.style';
const StyledDialog = styled(Dialog, {
    shouldForwardProp: (prop) => prop !== "overlayStyle" && prop !== 'bodyStyle'
        && prop !== 'isMobileOnly',
})(({ overlayStyle, bodyStyle, isMobileOnly }) => ({
    '.MuiBackdrop-root': overlayStyle,
    '.MuiPaper-root': bodyStyle,
    '.MuiDialog-container': {
        height: isMobileOnly ? '100vh' : '100%',
        marginTop: isMobileOnly ? '16px' : '0',
        paddingTop: isMobileOnly ? '-16px' : '0',
        boxSizing: 'border-box',
        mozBoxSizing: 'border-box'
    },
    '.V5Dialog-container': {
        height: isMobileOnly ? '100vh' : '100%',
        marginTop: isMobileOnly ? '16px' : '0',
        paddingTop: isMobileOnly ? '-16px' : '0',
        boxSizing: 'border-box',
        mozBoxSizing: 'border-box'
    }
}));
export const CustomModal = ({ withCloseIcon, withGoBackIcon, breakpointFullscreen, isOpen, onClose, onGoBack, children, dataQa, extraClassName, disableBackdropClick = false, title, footer, overlayStyle, titleStyle, bodyStyle, footerStyle, dialogContentStyle, contentTextStyle, }) => {
    const [open, setOpen] = useState(isOpen);
    const [scroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const theme = globalTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down(breakpointFullscreen !== null && breakpointFullscreen !== void 0 ? breakpointFullscreen : 'sm'));
    const { md } = useBreakpoint();
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    const onCloseDefault = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };
    const onGoBackDefault = () => {
        setOpen(false);
        if (onGoBack) {
            onGoBack();
        }
    };
    const handleOnClose = (_event, reason) => {
        if (disableBackdropClick) {
            if (reason !== 'backdropClick') {
                onCloseDefault();
            }
        }
        else {
            onCloseDefault();
        }
    };
    return (React.createElement(StyledDialog, { scroll: scroll, open: open, className: extraClassName ? extraClassName : '', onClose: handleOnClose, fullScreen: fullscreen, onBackdropClick: onCloseDefault, "data-qa": dataQa !== null && dataQa !== void 0 ? dataQa : null, overlayStyle: overlayStyle, bodyStyle: bodyStyle, TransitionComponent: CustomTransition, isMobileOnly: md.mobile && !md.isEmbeddedInBuyerApp ? true : false },
        title && (React.createElement(DialogTitle, { sx: titleStyle },
            withGoBackIcon && React.createElement(StyledChevronIcon, { onClick: onGoBackDefault }),
            title,
            withCloseIcon && React.createElement(StyledCloseIcon, { onClick: onCloseDefault }))),
        React.createElement(DialogContent, { sx: dialogContentStyle, dividers: !!title && scroll === 'paper' },
            withGoBackIcon && !title && React.createElement(StyledChevronIconNoTitle, { onClick: onGoBackDefault }),
            withCloseIcon && !title && React.createElement(StyledCloseIconNoTitle, { onClick: onCloseDefault }),
            React.createElement(DialogContentText, { sx: contentTextStyle, id: "scroll-dialog-description", ref: descriptionElementRef, tabIndex: -1 }, children)),
        footer && React.createElement(DialogActions, { sx: footerStyle }, footer)));
};
